<template>
  <div :class="{ loading }" class="template-container">
    <router-view />
    <b-loading
      :is-full-page="true"
      v-model="loading"
      :can-cancel="true"
    ></b-loading>
  </div>
</template>

<script>
export default {
  computed: {
    user() {
      return this.$store.getters.user;
    },
    loading() {
      return this.$store.getters.loading;
    },
  },
  sockets: {
    connect() {
      // Fired when the socket connects.
      this.$store.commit("isConnected", true);
    },
    disconnect() {
      // Fired when the socket disconnect.
      this.$store.commit("isConnected", false);
    },
  },
  mounted() {
    //faz join do usuário nos offices
    if (!this.user._id) return;
    this.$socket.emit("join", {
      user: this.user._id,
      role: this.user.role,
    });
  },
};
</script>
<style>
html,
body,
div.template-container {
  height: 100% !important;
}
body {
  padding-top: 60px !important;
  font-family: Roboto, "Helvetica Neue", Arial, sans-serif !important;
  font-weight: normal !important;
  line-height: 1.3 !important;
  color: #212529 !important;
  background-color: #fff !important;
}
form .columns {
  margin-bottom: 0 !important;
}
.section {
  padding: 0.5rem !important;
}
.loading {
  cursor: wait !important;
}
</style>